module.exports = __webpack_public_path__ + "img/0 (1).6454a63b.jpg";